<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'systemDictionary',
})
</script>
<template>
  <div class="">
    <a-card>
      <div class="system-dictionary-search">
        <a-form :model="state.tableData.param" class="global-search-form">
          <a-row :gutter="24">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="字典名称">
                <a-input v-model:value="state.tableData.param.name" placeholder="请输入字典名称" :maxlength="20" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="字典编码">
                <a-input v-model:value="state.tableData.param.code" placeholder="请输入字典编码" :maxlength="20" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="card-col-action btn-group">
                <ant-button class="search mr-[10px]!" @click="getTableData" type="primary">
                  <SearchOutlined />查询
                </ant-button>
                <ant-button class="resetFun" @click="resetFun" type="primary">
                  <RedoOutlined />重置
                </ant-button>
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="card-col-action flex justify-start md:justify-end">
                <ant-button class="add" @click="openDialog('add', {})" type="primary" v-auth="'dictionary.add'">
                  <PlusOutlined />新增字典
                </ant-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <ant-table :columns="columns" :data-source="state.tableData.data" :loading="state.tableData.loading"
        :pagination="false" row-key="id">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'action'">
            <div class="table-action-left">
              <a-button type="link" size="small" @click="openDialog('edit', record)"
                v-auth="'dictionary.edit.info'">编辑</a-button>
              <a-button type="link" size="small" @click="openDialogConfig(record)"
                v-auth="'dictionary.edit'">字典配置</a-button>
              <a-button type="link" size="small" danger @click="onDelete(record)"
                v-auth="'dictionary.del'">删除</a-button>
            </div>
          </template>
        </template>
      </ant-table>
      <ant-pagination v-model:current="state.tableData.param.pageNum" v-model:page-size="state.tableData.param.pageSize"
        :total="state.tableData.total" :page-size-options="['10', '20']" show-size-changer
        :show-total="(total) => `共 ${total} 条`" :showQuickJumper="true" @change="onPageChange"
        @show-size-change="onShowSizeChange" />
    </a-card>
    <DictionaryDialog ref="DictionaryDialogFormRef" @create-update="createUpdate" />
    <ConfigDialog ref="ConfigDialogRef" @update-dict-info="updateDictInfo" />
  </div>
</template>

<script setup lang="ts" name="systemDictionary">
import { reactive, ref, onMounted, h } from 'vue'
import { message, Modal } from 'ant-design-vue'
import { SearchOutlined, PlusOutlined, RedoOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import DictionaryDialog from './dialog.vue'
import ConfigDialog from './dialogConfig.vue'
import { useDictionary } from '@/store/system/dictionary'
import { fetchWithPaginationFallback } from '@/utils/paginationFallback'
import type { DictionaryConfigTable } from '@/store/system/dictionary'
const dictionaryStore = useDictionary()
const DictionaryDialogFormRef = ref()
const ConfigDialogRef = ref()

const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id', width: 120, ellipsis: true },
  { title: '字典名称', dataIndex: 'name', key: 'name', width: 200, ellipsis: true },
  { title: '字典编码', dataIndex: 'code', key: 'code', width: 200, ellipsis: true },
  { title: '描述', dataIndex: 'note', key: 'note', ellipsis: true },
  { title: '更新时间', dataIndex: 'modifyTime', key: 'modifyTime', ellipsis: true },
  { title: '操作', key: 'action', width: 200 }
]

const state = reactive({
  tableData: {
    data: [] as any[],
    total: 0,
    loading: false,
    param: {
      pageNum: 1,
      pageSize: 10,
      name: '',
      code: ''
    }
  }
})

const resetFun = () => {
  state.tableData.param.name = ''
  state.tableData.param.code = ''
  state.tableData.param.pageNum = 1
}

const getTableData = async () => {
  state.tableData.loading = true
  try {
    const data: any = await fetchWithPaginationFallback(
      (param) => dictionaryStore.dictList(param),
      state.tableData.param
    )
    state.tableData.data = data.records || []
    state.tableData.total = data.total || 0
    state.tableData.param.pageNum = data.pageNum ?? state.tableData.param.pageNum
  } finally {
    state.tableData.loading = false
  }
}

const openDialog = (type: string, row: any) => {
  DictionaryDialogFormRef.value.openDialog(type, row)
}

const openDialogConfig = (row: any) => {
  dictionaryStore.getDictInfo(row.id).then((data: any) => {
    ConfigDialogRef.value.openDialog(row.id, data || [])
  })
}

const onDelete = (row: any) => {
  Modal.confirm({
    transitionName: '',
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    content: `此操作将永久删除字典："${row.name}"，是否继续?`,
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      return dictionaryStore.deleteDict({ id: row.id }).then(() => {
        message.success('删除成功')
        getTableData()
      })
    }
  })
}

const onPageChange = (page: number) => {
  state.tableData.param.pageNum = page
  getTableData()
}

const onShowSizeChange = (_current: number, size: number) => {
  state.tableData.param.pageSize = size
  state.tableData.param.pageNum = 1
  getTableData()
}

const createUpdate = async (viewType: string, paramData: any) => {
  await getTableData()
  DictionaryDialogFormRef.value.closeDialog()
}

const updateDictInfo = async () => {
  await getTableData()
  ConfigDialogRef.value.closeDialog()
}

onMounted(() => {
  console.log('systemDictionary onMounted')
  getTableData()
})
</script>

<style scoped lang="less">
.ml10 {
  margin-left: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt15 {
  margin-top: 15px;
}

.btn-group {
  display: flex;
  white-space: nowrap;
}
</style>
